import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AddAccessories from '../layout/accessories/AddAccessories'
import AccessoriesLayout from '../layout/accessories/AccessoriesLayout'
import AccessoriesSpecificationLayout from '../layout/accessories/AccessoriesSpecificationLayout'
import AccessoriesDependLayout from "../layout/accessories/AccessoriesDependLayout";

function AccessoriesPage() {

  return (
    <>
      <Routes>
        <Route path="/" element={<AccessoriesLayout />} />
        <Route path="/add" element={<AddAccessories />} />
        <Route path="/update/:id" element={<AddAccessories />} />
        <Route path="/main/specification/:id" element={<AccessoriesSpecificationLayout />} />
        <Route path="/depend/specification/:rowId/" element={<AccessoriesDependLayout />} />
      </Routes>
    </>
  )
}

export default AccessoriesPage
